import { Injectable, inject } from '@angular/core';
import { ProductCategoryDataService } from '@warema/shared/company-search/data-access';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductApiService {
    private readonly _productCategoryDataService = inject(ProductCategoryDataService);

    public getSelectedCategoriesIds(): Observable<Array<number>> {
        return this._productCategoryDataService.selectedSubProductCategoriesIds$;
    }

    public getSelectedCategoriesTranslationKeys(): Observable<Array<string>> {
        return this._productCategoryDataService.selectedSubProductCategoriesTranslationKeys$;
    }

    public validateProductCategories(): void {
        this._productCategoryDataService.validateProductCategories();
    }
}
